import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'search.html',
})
export class VrProfitSearchPage {
    paras = {
        startDate: '',
        endDate: '',
        userName: '',
        pageIndex: 1,
        pageSize: 30,
    };

    constructor(
        private navpars: NavParams,
        private viewCtrl: ViewController
    ) {
        this.paras = this.navpars.get('paras');
    }

    //确认按钮
    //TQQ 2018-01-26
    okSearch() {
        this.dismiss(this.paras);
    }

    //取消按钮
    //TQQ 2018-02-26
    dismiss(data?) {
        this.viewCtrl.dismiss(data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/vrprofitreport/search.ts